import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bity': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M78.4 67.2C173.8-22 324.5-24 421.5 71 435.8 85.1 415.1 108.1 399.1 92.5 314.3 10.1 183.3 12.2 100.2 89.3 83.9 104.4 63.7 81 78.4 67.2zM177.3 485.8C196.6 491.5 206.6 462.2 185.2 455.8 73 421.9 9.4 306.1 37.7 194.8 42.7 175.2 12.8 166.7 7.5 187.7-24.6 315.1 48.6 447.5 177.3 485.8zM325.4 483.8C447.3 443.6 518.3 316.9 489.8 192.8 485.3 173.1 454.9 179 459.8 200.7 484 308.4 422.7 418.6 316.6 454.1 295.4 461.1 306.2 490.1 325.4 483.8zM262.5 404.8L262.7 333C262.7 324.8 256.1 318.2 247.9 318.2 239.7 318.2 233.1 324.9 233.1 333L232.9 404.8C232.9 413 239.5 419.6 247.7 419.6S262.5 413 262.5 404.8zM333.5 135.8C335.6 226.7 338.2 267.7 248 268.3 155.5 267.6 161.1 224 162.5 135.8 162.5 114 130 116.2 130 135.8V207.4C130 276.7 190.7 298.3 248 297.5 305.3 298.3 366 276.7 366 207.4V135.8C366 116.2 333.5 114 333.5 135.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bity.js
// module id = 8e7Q
// module chunks = 144